export default "__VITE_ASSET__4e1c3d94__"